// Parent/student attendance report pages (student/Attendance, student/Activities).
// Every string must stay globally unique across sagas — grep before adding.
export const STUDENT_ATTENDANCE_REPORT_SETTINGS = 'STUDENT_ATTENDANCE_REPORT_SETTINGS'
export const STUDENT_ATTENDANCE_INDIVIDUAL = 'STUDENT_ATTENDANCE_INDIVIDUAL'
export const STUDENT_ATTENDANCE_COMBINED = 'STUDENT_ATTENDANCE_COMBINED'
export const STUDENT_ATTENDANCE_PARENT_RESPONSE = 'STUDENT_ATTENDANCE_PARENT_RESPONSE'
export const STUDENT_ATTENDANCE_ACTIVITY_INDIVIDUAL = 'STUDENT_ATTENDANCE_ACTIVITY_INDIVIDUAL'
export const STUDENT_ATTENDANCE_ACTIVITY_COMBINED = 'STUDENT_ATTENDANCE_ACTIVITY_COMBINED'
